import MyTypography from "@saleor/components/MyTypography";
import { makeStyles } from "@saleor/macaw-ui";
import classNames from "classnames";
import React from "react";

interface InputDisableProps {
  value: string;
  id?: string;
  testId?: string;
  className?: string;
}

const useStyles = makeStyles(
  theme => ({
    root: {
      minHeight: "34.5px",
      width: "100%",
      padding: "0.7rem 1.6rem",
      background: theme.palette.background.default,
      borderRadius: "4px"
    }
  }),
  { name: "TextInputDisable" }
);

const TextInputDisable: React.FC<InputDisableProps> = props => {
  const { value, id, testId, className } = props;
  const classes = useStyles();

  return (
    <MyTypography
      id={id}
      data-testid={testId ?? id}
      className={classNames(classes.root, className)}
      variant={"body3"}
    >
      {value}
    </MyTypography>
  );
};

export default TextInputDisable;
